export const DELIVERY_CONTACT_NUMBER = '949449467';

export const PAYMENT_METHOD_NAME = {
  cash: 'Efectivo',
  transfer: 'Transferencia',
  credit: 'Credito',
};

export const TIME_MS_TO_RESTORE_SCROLL = 250;
